import { Immutable } from "immer";
import React from "react";
import { ProductReviewsSSR } from "tsi-common-react/src/apps/reviews/ProductReviewsSSR/index";
import { ReviewsComponentTypes } from "tsi-common-react/src/apps/reviews/constants";

import { templates } from "@reactivated";

export const Template = (
    props: Immutable<templates.ProductReviewsTemplate>,
): React.JSX.Element => {
    return (
        <ProductReviewsSSR
            {...props}
            starHasStroke={true}
            reviewsComponentType={ReviewsComponentTypes.CAROUSEL}
            showWriteReviewButton={false}
            isCollapsedView={true}
        />
    );
};
